import { render, staticRenderFns } from "./detail_config_dataset_group_list_item_add.vue?vue&type=template&id=1dfdc7e0&scoped=true"
import script from "./detail_config_dataset_group_list_item_add.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_group_list_item_add.vue?vue&type=script&lang=js"
import style0 from "./detail_config_dataset_group_list_item_add.vue?vue&type=style&index=0&id=1dfdc7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfdc7e0",
  null
  
)

export default component.exports